module.exports = __webpack_public_path__ + "static/antd-table-sorting-41132fcba156ca7d4a9dc0af64fd6477.png";